import React, { useState } from 'react'
import PageHeader from '../components/PageHeader'
import { awsBaseUrl } from '../lib/util/utilities'
import videoIcon from '../images/video-camera.png'
import "../scss/vkycStyles.scss"
import { useNavigate } from 'react-router-dom'
import { useStartVkycVerificationMutation } from '../lib/services/vkycApi'
import { useEffect } from 'react'

const VkycVerification = () => {
    const [startVkycVerification, { data: vkycData }] = useStartVkycVerificationMutation();
    const navigate = useNavigate();
    const [disable, setDisable] = useState(false);

    const handleStartVkycVerification = async () => {
        setDisable(true);
        const jwt_token = localStorage.getItem('jwt');
        const scrt = localStorage.getItem('secret');
        if (jwt_token && scrt) {
            startVkycVerification({ jwt_token, scrt });
        }
    }

    const handleDoItLater = () => {
        navigate(-1)
    };

    useEffect(() => {
        if (vkycData) {
            window.location.href = vkycData.vkyc_redirection_url || "";
        }
    }, [vkycData]); 

  return (
    <div className='external-wrapper'>
        <div className='page-content'>
            <PageHeader />
            <div className="vkyc-verification-content">
                <div className="vkyc-picture-wrapper">
                    <img src={`${awsBaseUrl}/lending/vkyc-picture.png`} alt="Video verification" width={164} height={164} />
                </div>
                <div className="main-title-wrapper">
                    <img src={videoIcon} alt=''/>
                    <p>Video verification</p>
                </div>
                <p className="description">
                    Complete a quick video call to unlock your full limit.
                </p>

                <div className="documents-card">
                    <div className="document-item">
                        <img src={`${awsBaseUrl}/lending/vkyc_profileCard.png`} alt="PAN" width={24} height={24} className="document-icon" />
                        <span>Please keep your <strong> National Identity Documents like PAN Card, Aadhaar Card </strong> etc. handy for the call. You may need to upload a copy.</span>
                    </div>
                    <div className="document-item">
                        <img src={`${awsBaseUrl}/lending/vkyv_location.png`} alt="Aadhaar" width={24} height={24} className="document-icon" />
                        <span>Please allow access to your <strong>location, microphone, and camera.</strong> As per regulatory guidelines, these must remain on during the call.</span>
                    </div>
                    <div className="document-item">
                        <img src={`${awsBaseUrl}/lending/vkyc_wifi.png`} alt="Aadhaar" width={24} height={24} className="document-icon" />
                        <span>Please ensure that you have a <strong>stable internet connection</strong>  during the call.</span>
                    </div>
                    <div className="badges-wrapper">
                    <img src={`${awsBaseUrl}/lending/safe_secure.png`} alt='' width={112} height={18} />
                    <img src={`${awsBaseUrl}/lending/time_2min.png`} alt='' width={118} height={18} />
                    </div>
                </div>

                <div className="actions">
                    <button className={`btn btn-primary start-verification-button ${disable ? "disabled" : ""}`} onClick={handleStartVkycVerification}>
                        Start Video Verification
                        <img src={`${awsBaseUrl}/lending/video-camera-inverted.png`} alt="" width={24} height={24} />
                    </button>
                    <button className={`btn btn-primary-outlined ${disable ? "disabled" : ""}`} onClick={handleDoItLater}>
                        Do it later
                    </button>
                    <p className="powered-by">Powered by Akara Capital Advisors Private Limited</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default VkycVerification